import { Image as AntImage } from 'antd'
import type { ComponentProps } from 'react'

type AntImageProps = ComponentProps<typeof AntImage>

export interface AppImageProps extends AntImageProps {}

export const AppImage = (props: AppImageProps) => <AntImage {...props} />

export const AppImagePreviewGroup = AntImage.PreviewGroup
